module.exports = __webpack_public_path__ + "static/media/7ICJ1.1c03247f.jpg";